//path: src\hooks\useAuthUser.tsx

import { AuthContext } from './authContext';
import { useContext } from 'react';
import { BackendUser as User } from '@/infrastructure/clients/BackendClient';

interface UseAuthUserResult {
  user: User | null;
  loading: boolean;
  refreshUser: () => Promise<void>;
}

export const useAuthUser = (): UseAuthUserResult => {
  const { user, loading, refreshUser } = useContext(AuthContext);
  return { user, loading, refreshUser };
};
